// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarTwoToneSvg from "@ant-design/icons-svg/es/asn/DollarTwoTone";
import AntdIcon from '../components/AntdIcon';

var DollarTwoTone = function DollarTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarTwoToneSvg
  }));
};

DollarTwoTone.displayName = 'DollarTwoTone';
export default React.forwardRef(DollarTwoTone);